import React from 'react';
import { SongsTable } from '../../components/SearchSongsTable';
import { SearchBar } from '../../components/SearchBar';
import { SearchStyle, SearchHeader, SearchContent } from './Search.style';
interface SearchProps {}

const Search: React.FC<SearchProps> = () => {
  return (
    <SearchStyle>
      <SearchHeader>
        <div className="search-header-content">
          <div className="search-title-section">
            <h1 className="search-page-title">Discover Music</h1>
            <p className="search-page-subtitle">
              Search for songs, artists, albums, and podcasts from your favorite platforms
            </p>
          </div>

          <div className="search-controls-section">
            <div className="search-bar-container">
              <SearchBar />
                <img
                  alt="spotify"
                  src={'./../static/Spotify_Logo_RGB_Green.png'}
                  className="platform-icon"
                  style={{ width: '70px' }}
                />
            </div>
          </div>
        </div>
      </SearchHeader>

      <SearchContent>
        <SongsTable />
      </SearchContent>
    </SearchStyle>
  );
};

export default Search;
